<template>
  <div class="tree-container" ref="treeContainer" @mousewheel="handleScroll">
    <el-tree ref="treeObj" style="max-width: 600px;" :data="treeNodeData" :props="defaultProps"
      @node-click="handleNodeClick" empty-text="无可播放数据" node-key="key" :highlight-current="true">
      <template #default="{ data, node }" >
        <div class="item" :class="node.key == currentId ? 'active' : ''" :title="data.label" :data-id="node.key">
          <div class="line" :style="`left:${18 * node.level - 3}px`"></div>
          <div class="svg" v-if="!data.isFile">
            <svg t="1650195769498" v-if="node.expanded" class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4924" width="128" height="128">
              <path
                d="M671.6928 287.744L594.0736 138.24H181.1456v274.8416H886.4768l11.9808 37.8368 82.0224 259.7888V287.744h-308.7872z"
                fill="#FFBA3D" p-id="4925"></path>
              <path d="M181.1456 468.0192H43.52L175.4112 885.76h804.6592l-131.9424-417.7408H181.1456z" fill="#FFBA3D"
                p-id="4926"></path>
            </svg>
            <svg t="1650195647416" v-else class="icon" viewBox="0 0 1024 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="4772" width="128" height="128">
              <path d="M948.48 880.896H107.52V138.24h398.6432l94.6688 174.7456h347.648v567.9104z" fill="#F4A019"
                p-id="4773"></path>
            </svg>
          </div>
          <div class="svg" v-else>
            <svg t="1650195885400" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="14132" width="128" height="128">
              <path
                d="M699.68 673.24c-1.4-8.74-9.67-14.63-18.41-13.24h-335.6c-6.83 1.14-12.15 6.46-13.24 13.24-1.45 8.74 4.5 17.01 13.24 18.41h335.6c1.76 0.31 3.52 0.31 5.22 0 8.74-1.4 14.64-9.67 13.19-18.41zM699.68 348.8c-1.4-8.74-9.67-14.69-18.41-13.24h-335.6c-6.83 1.14-12.15 6.41-13.24 13.24-1.45 8.74 4.5 16.96 13.24 18.41h335.6c1.76 0.31 3.52 0.31 5.22 0 8.74-1.44 14.64-9.67 13.19-18.41zM699.68 592.15c-1.4-8.74-9.67-14.69-18.41-13.24h-335.6a15.919 15.919 0 0 0-13.24 13.24c-1.45 8.74 4.5 16.96 13.24 18.41h335.6c1.76 0.26 3.52 0.26 5.22 0 8.74-1.44 14.64-9.67 13.19-18.41z"
                p-id="14133"></path>
              <path
                d="M674.75 72.21c-3-3.1-7.19-4.86-11.53-4.86H243.44v-0.1c-41.73 0.05-75.55 33.87-75.6 75.65v741.06c0.05 41.73 33.87 75.55 75.6 75.6h535c41.73-0.05 75.55-33.87 75.65-75.6V251.49L674.75 72.21z m4.56 50l124.98 124.98h-91.37c-18.51-0.1-33.51-15.1-33.61-33.66v-91.32z m147.63 761.75c-0.1 23.94-19.49 43.33-43.44 43.44H243.44c-23.94-0.1-43.33-19.49-43.44-43.44V142.89c0.1-23.99 19.49-43.39 43.44-43.49h403.65v113.61c0.1 36.3 29.53 65.78 65.83 65.83h114.02v605.12z"
                p-id="14134"></path>
              <path
                d="M712.92 278.84c-36.3-0.05-65.72-29.53-65.83-65.83V99.4H243.44c-23.94 0.1-43.33 19.49-43.44 43.49v741.06c0.1 23.94 19.49 43.33 43.44 43.44H783.5c23.94-0.1 43.33-19.49 43.44-43.44V278.84H712.92z m-26.43 412.81c-1.71 0.31-3.46 0.31-5.22 0h-335.6c-8.74-1.4-14.69-9.67-13.24-18.41 1.09-6.77 6.41-12.1 13.24-13.24h335.6c8.74-1.4 17.01 4.5 18.41 13.24 1.45 8.74-4.45 17.01-13.19 18.41z m0-81.09c-1.71 0.26-3.46 0.26-5.22 0h-335.6c-8.74-1.45-14.69-9.67-13.24-18.41a15.919 15.919 0 0 1 13.24-13.24h335.6c8.74-1.45 17.01 4.5 18.41 13.24 1.45 8.74-4.45 16.97-13.19 18.41z m0-81.13c-1.71 0.31-3.46 0.31-5.22 0h-335.6c-8.74-1.45-14.69-9.67-13.24-18.41 1.09-6.77 6.41-12.1 13.24-13.24h335.6c8.74-1.4 17.01 4.5 18.41 13.24 1.45 8.74-4.45 16.96-13.19 18.41z m0-81.08c-1.71 0.26-3.46 0.26-5.22 0h-335.6c-8.74 1.4-17.01-4.5-18.41-13.24-1.45-8.74 4.5-17.01 13.24-18.41 1.71-0.31 3.46-0.31 5.17 0h335.6c8.74-1.45 17.01 4.5 18.41 13.24 1.45 8.69-4.45 16.96-13.19 18.41z m0-81.14c-1.71 0.31-3.46 0.31-5.22 0h-335.6c-8.74-1.45-14.69-9.67-13.24-18.41 1.09-6.83 6.41-12.1 13.24-13.24h335.6c8.74-1.45 17.01 4.5 18.41 13.24 1.45 8.74-4.45 16.97-13.19 18.41z"
                fill="#FFEA8F" p-id="14135"></path>
              <path d="M804.29 247.19h-91.37c-18.51-0.1-33.51-15.1-33.61-33.66v-91.32l124.98 124.98z" fill="#ED8D22"
                p-id="14136"></path>
              <path
                d="M699.68 429.94c-1.4-8.74-9.67-14.69-18.41-13.24h-335.6c-1.71-0.31-3.46-0.31-5.17 0-8.74 1.4-14.69 9.67-13.24 18.41 1.4 8.74 9.67 14.63 18.41 13.24h335.6c1.76 0.26 3.52 0.26 5.22 0 8.74-1.45 14.64-9.72 13.19-18.41zM699.68 511.02c-1.4-8.74-9.67-14.63-18.41-13.24h-335.6c-6.83 1.14-12.15 6.46-13.24 13.24-1.45 8.74 4.5 16.96 13.24 18.41h335.6c1.76 0.31 3.52 0.31 5.22 0 8.74-1.45 14.64-9.67 13.19-18.41z"
                p-id="14137"></path>
            </svg>
          </div>
          <div class="text ellipsis">
            {{ data.label }}
          </div>
        </div>
      </template>
    </el-tree>
  </div>
</template>
<script lang="ts" setup>
import { nextTick, ref, onMounted, watch } from 'vue'
import { useMetaDataStore } from "@/store/metaDataStore";
import { useFrameDataStore } from "@/store/frameDataStore";
import { ElTree, dayjs, ElMessage } from 'element-plus';
import { useRouter } from 'vue-router'

const metaDataStore = useMetaDataStore()
const frameDataStore = useFrameDataStore()
const treeObj = ref(null);
const currentId = ref()
const treeContainer = ref()
const router = useRouter();
interface Tree {
  key: string,
  label: string
  children?: Tree[]
  startTs: string
  isFile: boolean
}
const defaultProps = {
  children: 'children',
  label: 'label',
}

const handleScroll = (e:any)=>{
  e.preventDefault(); 
  const scrollDistance = 60; 
  const scrollAmount = (e.deltaY > 0 ? 1 : -1) * scrollDistance;
  (e.currentTarget as HTMLElement).scrollBy(0, scrollAmount);
}

const handleNodeClick = (data: Tree) => {
  currentId.value = data.key;
  if (data.isFile) {
    frameDataStore.setCurrentTimeInterval(data.startTs, data.endTs, data.missing,data.region)
  }
  
  const currentQuery = { ...router.currentRoute.value.query };
  currentQuery.ts = data.startTs / 1000 || 0; 
  router.push({ query: currentQuery });  
}
const treeNodeData = ref()

let dataList_map = new Map();//播放列表的整理map
/***
 * 监控不同车的播放列表
 */
watch(() => metaDataStore.playlist_data, async (playList: any) => {
  console.log('要加载的时间区间', playList);
  let queryStart = frameDataStore.getQueryStartTs();
  let currentVehicleId = frameDataStore.currentVehicleId;
  currentId.value = ""
  if (playList?.length > 0) {
    dataList_map.clear();
    playList.sort((a: any, b: any) => b.start - a.end);
    playList.forEach((item: any) => {
      let date_label = dayjs(item.start * 1000).format('MM-DD');
      if (!dataList_map.has(date_label)) {
        dataList_map.set(date_label, {
          key: `${currentVehicleId}-${date_label}`,
          label: date_label,
          children: [],
          isFile: false,
        })
      }
      const start = item.start * 1000;
      const end = item.end * 1000;
      let startTime = dayjs(start).format('HH:mm:ss');
      let endTime = dayjs(end).format('HH:mm:ss');
      let label = `${date_label}_${startTime}-${endTime}`
      let key = `${currentVehicleId}-${date_label}-${label}`;
      dataList_map.get(date_label).children.push({
        key,
        label,
        isFile: true,
        startTs: start,
        endTs: end,
        startTime,
        endTime,
        missing: item.missing,
        region:item.region
      })
      if (queryStart > 0) {
        if (queryStart >= item.start && queryStart < item.end) {
          //找当跳转的要播放的片段 
          currentId.value = key;
          frameDataStore.setCurrentTimeInterval(start, end, item.missing,item.region)
        }
      }
    })
    treeNodeData.value = Array.from(dataList_map.values())
    scrollToTop(currentId.value);
  } else {
    //没有播放数据
    treeNodeData.value = [];
  }
},
);
// 获取当前项并设置active样式
const scrollToTop = async (key: string) => {
  nextTick(() => {
    treeObj.value.setCurrentKey(key);
    const node = treeObj.value.getNode(key);
    nextTick(() => {
      if (node) {
        const el = treeObj.value.$el.querySelector(`[data-id="${node.key}"]`);
        if (el && treeContainer.value) {
          const scrollToElement = () => {
             // Get the container and element positions
            const containerRect = treeContainer.value.getBoundingClientRect();
            const elRect = el.getBoundingClientRect();
            
            // Calculate the scroll position
            const scrollPosition = elRect.top - containerRect.top + 
              treeContainer.value.scrollTop - (containerRect.height / 2) + (elRect.height / 2);
            // Set the scroll position
            treeContainer.value.scrollTo({
              top: scrollPosition,
              behavior: 'smooth',
            });
            
            // 检查是否已经可见，如果不可见则继续等待
            const isVisible = elRect.top >= containerRect.top && 
              elRect.bottom <= containerRect.bottom;
            
            if (!isVisible) {
              // 如果不可见，继续等待并重试
              setTimeout(scrollToElement, 50);
            }
          };
          
          requestAnimationFrame(scrollToElement);
        }
      }
    });
  });
};

watch(() => frameDataStore.play_next_auto_ST_time, (time) => {
  if (time > 0 && frameDataStore.play_next_auto == 0) {
    //有跳转时间并且配置了自动跳转下一个
    let timePlay = time / 1000;
    let playItem = metaDataStore.playlist_data.find((item: any) => item.start <= timePlay && item.end >= timePlay);
    if (playItem) {
      //查找到合适下一个；
      let currentVehicleId = frameDataStore.currentVehicleId;
      let date_label = dayjs(playItem.start * 1000).format('MM-DD');
      const start = playItem.start * 1000;
      const end = playItem.end * 1000;
      let startTime = dayjs(start).format('HH:mm:ss');
      let endTime = dayjs(end).format('HH:mm:ss');
      let label = `${date_label}_${startTime}-${endTime}`
      let key = `${currentVehicleId}-${date_label}-${label}`;
      currentId.value = key;
      frameDataStore.setCurrentTimeInterval(start, end, playItem.missing,playItem.region);
    }
  }
})
</script>

<style lang="less" scoped>
.tree-container {
  max-height: 160px;
  /* 设置容器的最大高度 */
  height: calc(100% - 50px);
  overflow-y: auto;
  /* 允许垂直滚动 */
  width: 100%;
  /* 确保容器的宽度占满父元素 */
  scroll-behavior:smooth;
}

.el-tree {
  background-color: transparent !important;
  color: #fff;
}

:deep(.el-tree-node__expand-icon) {
  display: none !important;
}

.item {
  height: 20px;
  padding: 0 10px 0 0;
  display: flex;
  align-items: center;
  overflow: hidden;
  cursor: pointer;
  color: #fff;
  white-space: pre-wrap;

  svg {
    fill: #fff;
    width: 8px;
    height: 8px;
    flex-shrink: 0;
    margin-right: 2px;
  }

  .line {
    content: '';
    position: absolute;
    top: 18px;
    height: calc(100% - 20px);
    transform: translateX(-6px);
    border-right: 1px dashed #fff;
    display: none;
  }

}

.active,
.active>.item {
  color: var(--theme) !important;
}

:deep(.el-tree-node__content) {
  height: 16px;
  font-size: 14px;
  background: none !important;
  &:hover {
    background: none !important;
  }
}

:deep(.el-tree) {
  background: none;
}

:deep(.el-tree-node) {
  white-space: none !important;
  position: relative;
}

:deep(.is-expanded)>.el-tree-node__content>.item>.line {
  display: block;
}

.ellipsis {
  cursor: pointer;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
